// Route pattern for Route matching
export const personalSettingsRoute = '/account/:section';

export const personalInfoPath = () => '/account/personalInfo';
export const rossumLabsPath = () => '/account/rossumLabs';
export const changeFeatureFlagsPath = () => '/account/changeFeatureFlags';
export const discoveryCallSurveysPath = () => '/account/discoveryCallSurveys';
